"use strict";module.exports={application_module:"not-set",application_name:"not-set",business_area:"not-set",customer_segment:"not-set",event_source:"@gjensidige/core-analytics",event_version:"11.6.0"};
//# sourceMappingURL=index.js.map
